// ---------------------------------------------------------------------------
// Relative time, kept pure so it can be unit tested.
// ---------------------------------------------------------------------------

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Coarse and human. The organizer question is "has this volunteer synced since
 * Saturday", not "how many minutes ago" (PLAN 5.7), so precision past the
 * bucket boundary would be noise.
 */
export function relativeTime(iso: string | null, now: Date = new Date()): string {
  if (!iso) return 'never';

  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return 'never';

  const seconds = Math.round((now.getTime() - then) / 1000);
  if (seconds < 0) return 'just now';
  if (seconds < MINUTE) return 'just now';
  if (seconds < HOUR) return `${Math.floor(seconds / MINUTE)} min ago`;
  if (seconds < DAY) return `${Math.floor(seconds / HOUR)} h ago`;

  const days = Math.floor(seconds / DAY);
  return days === 1 ? 'yesterday' : `${days} days ago`;
}

/** Older than this and an organizer should be making a phone call (PLAN 5.7). */
export const STALE_SYNC_SECONDS = DAY;

export function isStale(iso: string | null, now: Date = new Date()): boolean {
  if (!iso) return true;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return true;
  return (now.getTime() - then) / 1000 > STALE_SYNC_SECONDS;
}
